// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select } from 'd3-selection';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import { stylePremium } from './utils/helpers';
import config from './config';
import graphic from './graphic';

// styles
import './styles/index.scss';

/* develblock:start */
import meta from './data/meta.json';

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta)
      .forEach((id) => {
        const node = document.querySelector(`.${id}`);

        if (node) {
          node.innerHTML = meta[id];
        }
      });
  }

  const { pymChild } = window;
  if (pymChild && pymChild.id && pymChild.id.endsWith('-showNav')) {
    document.querySelector('nav').style.display = 'block';
  }
  const parentLang = pymChild.parentUrl.split('?lang=')[1];
  if (parentLang) {
    document.getElementById('lang-toggle').value = parentLang;
    window.updateShare(parentLang);
    changeLanguage(parentLang);
  }
  pymChild.sendHeight();
};

const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

function draw(initialWidth) {
  const container = select('#graphic');
  container.html('');

  const fallbackWidth = container.node().clientWidth || 600;
  const safeWidth = initialWidth !== fallbackWidth ? fallbackWidth : initialWidth;
  const isMobile = safeWidth <= 500;

  const heightMultiplier = isMobile ? 1 : (9 / 16);
  const initialHeight = heightMultiplier * safeWidth;

  const props = { initialWidth: safeWidth, initialHeight, isMobile };

  const graphicConfig = config(props);
  graphic(graphicConfig, container, isMobile);
}
